import type { FreelancerAvailaleJobsLocales } from '../types';

const freelancerAvailableJobsLocales: FreelancerAvailaleJobsLocales = {
  accept: 'Accept',
  allAssignments: 'All assignments',
  allDistances: 'All distances',
  allServices: 'All services',
  applyFilters: 'Apply filters',
  assignment: 'assignment',
  assignments: 'Assignments',
  assignmentsOnThisDate: {
    one: 'You have %{count} assignment on this date!',
    other: 'You have %{count} assignments on this date!',
    zero: 'You have no assignments on this date',
  },
  availability: 'Availability',
  availableOnly: 'Only available days',
  competences: 'Competences',
  confirmAccept: 'Do you want to accept this assignment?',
  confirmInterest: 'Would you like to show interest in this assignment?',
  confirmInterestPeriod:
    'Would you like to show interest in these assignments?',
  confirmRefuse: 'Do you want to refuse this assignment?',
  confirmRefusePeriod: 'Do you want to refuse these assignments?',
  derivedJobMessage:
    'This assignment comes from a longer assignment assigned to you.',
  details: 'Details',
  done: 'Done!',
  feedbackAcceptError: 'Sorry, job is no longer available!',
  feedbackAcceptSuccess: 'Job accepted!',
  feedbackInterestSuccess: 'Completed succesfully!',
  filter: 'Filter',
  home: 'Home',
  interest: 'Choice',
  interestAssignments: 'Interest jobs',
  interested: 'Interested',
  invoices: 'Invoices',
  kilometer: 'kilometer',
  kindOfAssignment: 'Kind of assignment',
  logout: 'Logout',
  longerAssignment: 'Long assignment',
  longerAssignments: 'Longer assignments',
  minimumHourlyRate: 'minimum hourly rate',
  name: 'Name...',
  newAssignments: 'New assignments',
  noAvailableJobs: 'There are no jobs available right now.',
  noAvailablePeriodJobs: 'There are no period jobs available right now.',
  noCertificatesRequired: 'No certificates required',
  noResultsFound: 'No results found.',
  notVerified: 'Profile not verified',
  organisation: 'Organisation',
  personal: 'personal',
  personalAssignments: 'personal assignments',
  personalJobsNotification: {
    one: 'You have %{count} pending personal invitation, click here to enable the filter.',
    other:
      'You have %{count} pending personal invitations, click here to enable the filter.',
  },
  postCode: 'Postal Code',
  setAvailability:
    'You are not available on this date: {{date}}, do you want to set yourself available?',
  settings: 'Settings',
  singleCalls: 'Single calls',
  speed: 'Speed',
  toAsk: 'To ask',
  toCallToAction: 'To call to action',
  toInvite: 'To invite',
  toRefuse: 'To refuse',
  travelDistance: 'Travel distance',
  urgentAssignments: 'Urgent assignments',
  wholeDays: 'Whole days',
};

export default freelancerAvailableJobsLocales;
